import { FormikErrors } from 'formik'
import { FormModel } from './FormModel'

export function validate(model: FormModel): FormikErrors<FormModel> {
  const errors: FormikErrors<FormModel> = {}
  if (model.reminderFrequency < 1 || model.reminderFrequency > 999) {
    errors.reminderFrequency = 'Must be between 1 and 999'
  }
  return errors
}
